import type { PaperProps } from '@mui/material'
import MuiPaper from '@mui/material/Paper'
import { styled } from '@mui/material/styles'
import { shadows } from 'styles/theme'

type Shadow = 'low' | 'medium' | 'high'

type Props = Omit<PaperProps, 'elevation'> & { shadow?: Shadow }

const Paper = (props: Props) => {
  const { shadow = 'low', ...paperProps } = props
  return (
    <StyledPaper {...paperProps} elevation={0} shadow={shadow}>
      {props.children}
    </StyledPaper>
  )
}

export default Paper

const StyledPaper = styled(MuiPaper)<{ shadow: Shadow }>`
  box-shadow: ${({ shadow }) => shadows[shadow]};
`
